import { useEffect } from 'react';

import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { AtlassianLogo } from '@atlaskit/logo';
import { N20 } from '@atlaskit/theme/colors';

export const ErrorLocale = ({ locale }: { locale: string }) => {
	const intl = useIntl();
	const localeErrorHeader = intl.formatMessage({
		id: 'BxpUiSignup.SignupForm.localeErrorHeader',
		defaultMessage: 'We stand with Ukraine',
	});
	const localeErrorButtonText = intl.formatMessage({
		id: 'BxpUiSignup.SignupForm.localeErrorButtonText',
		defaultMessage: 'Learn more',
	});
	const localeErrorMessage = intl.formatMessage({
		id: 'BxpUiSignup.SignupForm.localeErrorMessage',
		defaultMessage:
			'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.',
	});

	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			event: 'blocked',
			action: 'blocked',
			actionSubject: 'signUp',
			actionSubjectId: 'signUpForm',
			product: 'marketing',
			blockType: 'geoIP',
			blockValue: locale,
		}).fire('signup');
	}, [createAnalyticsEvent, locale]);

	return (
		<div css={containerCss} data-testid="error-locale">
			<div css={logoContainerCss}>
				<AtlassianLogo appearance="brand" />
			</div>
			<h2>{localeErrorHeader}</h2>
			<p>{localeErrorMessage}</p>
			<Button
				appearance="link"
				href="https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine"
			>
				{localeErrorButtonText}
			</Button>
		</div>
	);
};

const containerCss = css({
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'column',
	margin: 'auto',
	textAlign: 'center',
	maxWidth: '410px',
	padding: '0 20px',
});

const logoContainerCss = css({
	alignItems: 'center',
	backgroundColor: N20,
	display: 'flex',
	height: '200px',
	justifyContent: 'center',
	marginBlockEnd: '22px',
	width: '100%',
	maxWidth: '300px',
});
